async function CreateUpdateCyclones(
    cycloneid,
    cyclonename,
    customer,
    quotenumber,
    cyclonetypeselection,
    sizemodel,
    captype,
    screenedtubularguard,
    desiredoperatingpressureloss,
    designairflow1,
    designairflow2,
    designairflow3,
    designairflow4,
    designairflow5,
    designairflow6,
    designairflow7,
    designairflow8,
    designairflow9,
    designairflow10,
    designairflow1notes,
    designairflow2notes,
    designairflow3notes,
    designairflow4notes,
    designairflow5notes,
    designairflow6notes,
    designairflow7notes,
    designairflow8notes,
    designairflow9notes,
    designairflow10notes,
    notes,
    createdby,
    modifiedby
) {

    if (true) {

        let response;

        let params = {
            "@CycloneID": cycloneid,
            "@CycloneName": cyclonename,
            "@Customer": customer,
            "@QuoteNumber": quotenumber,
            "@CycloneTypeSelection": cyclonetypeselection,
            "@SizeModel": sizemodel,
            "@CapType": captype,
            "@ScreenedTubularGuard": screenedtubularguard,
            "@DesiredOperatingPressureLoss": desiredoperatingpressureloss,
            "@DesignAirflow1": designairflow1,
            "@DesignAirflow2": designairflow2,
            "@DesignAirflow3": designairflow3,
            "@DesignAirflow4": designairflow4,
            "@DesignAirflow5": designairflow5,
            "@DesignAirflow6": designairflow6,
            "@DesignAirflow7": designairflow7,
            "@DesignAirflow8": designairflow8,
            "@DesignAirflow9": designairflow9,
            "@DesignAirflow10": designairflow10,
            "@DesignAirflow1Notes": designairflow1notes,
            "@DesignAirflow2Notes": designairflow2notes,
            "@DesignAirflow3Notes": designairflow3notes,
            "@DesignAirflow4Notes": designairflow4notes,
            "@DesignAirflow5Notes": designairflow5notes,
            "@DesignAirflow6Notes": designairflow6notes,
            "@DesignAirflow7Notes": designairflow7notes,
            "@DesignAirflow8Notes": designairflow8notes,
            "@DesignAirflow9Notes": designairflow9notes,
            "@DesignAirflow10Notes": designairflow10notes,
            "@Notes": notes,
            "@CreatedBy": createdby,
            "@ModifiedBy": modifiedby
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "164",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "Cyclones",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);
    }
}

export default CreateUpdateCyclones;